import { trimbleIdentityEnvironment } from '../trimble-identity-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { tidJwtSchema } from '../schemas/tid-jwt.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get TID JWT
 * @param code Authorization Code
 * @param client_id Application ID on Trimble Cloud
 * @param client_secret Application secret on Trimble Cloud
 * @param redirect_uri Whitelisted Callback URL on Trimble Cloud
 * @returns TID Jwt
 */
export function postTidToken(
  this: unknown,
  request: {
    code: string;
    client_id: string;
    client_secret: string;
    redirect_uri: string;
  }
) {
  const params = new URLSearchParams();
  params.append('grant_type', 'authorization_code');
  params.append('code', request.code);
  params.append('client_id', request.client_id);
  params.append('redirect_uri', request.redirect_uri);

  return fromFetch(
    new Request(trimbleIdentityEnvironment.resolve(this).tokenUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        Authorization: `Basic ${window.btoa(
          `${request.client_id}:${request.client_secret}`
        )}`,
      },
      body: params,
    })
  ).pipe(selectData(tidJwtSchema));
}
